import React from 'react';
import {useNavigate} from 'react-router-dom';
import {confermaCodice, rimanda} from '../../services/registrazioneApi';
import {regoleRegistrazione} from './Registrati';
import Nota from '../Vetrina/Nota';
import './Registrazione.css';
import i18next from 'i18next';

/**
 * CONTO IN ATTESA: cosa fare dopo la registrazione, per canale.
 *
 * COSA FA: email -> «controlla la posta» e «rimanda»; SMS -> casella per il
 * codice (conferma qui); Telegram -> pulsante che apre il bot col codice...
 * che pero' il sito NON conosce (lo genera user-management e lo manda al
 * postino): quindi il bot si apre e il cliente scrive /start; DA COLLEGARE:
 * il codice nella risposta di registrazione, cosi' il link porta gia' il
 * codice. COSA NON FA: non attiva il conto da sola, lo fa user-management.
 */
export default function ContoInAttesa() {
  const navigate = useNavigate();
  const regole = regoleRegistrazione();
  /* Letta UNA volta: dopo la conferma si toglie dal browser, e la pagina
     deve restare quella che era per mostrare l'esito. */
  const [attesa] = React.useState(() => {
    try { return JSON.parse(window.sessionStorage.getItem('lvc.contoInAttesa') || 'null'); } catch (e) { return null; }
  });
  const [codice, setCodice] = React.useState('');
  const [esito, setEsito] = React.useState({tono: '', testo: ''});
  const [invio, setInvio] = React.useState(false);

  if (!attesa) {
    return (
      <section className={'reg-pagina'}>
        <h1>{i18next.t('Conto in attesa')}</h1>
        <Nota>{i18next.t('Non c\'e\' una registrazione appena fatta in questo browser.')}{' '}<button type={'button'} className={'reg-link'} onClick={() => navigate('/register')}>{i18next.t('Registrati')}</button> o <button type={'button'} className={'reg-link'} onClick={() => navigate('/login')}>{i18next.t('accedi')}</button>.</Nota>
      </section>
    );
  }

  const conferma = async (ev) => {
    ev.preventDefault();
    setInvio(true);
    setEsito({tono: '', testo: ''});
    try {
      const m = await confermaCodice(codice.trim().toUpperCase(), attesa.skinId);
      setEsito({tono: 'ok', testo: m});
      try { window.sessionStorage.removeItem('lvc.contoInAttesa'); } catch (e) { /* niente */ }
    } catch (err) {
      setEsito({tono: 'errore', testo: `Errore ${err.codice || ''} - ${err.messaggio}`});
    }
    setInvio(false);
  };

  const rimandaOra = async () => {
    setInvio(true);
    setEsito({tono: '', testo: ''});
    try {
      const m = await rimanda(attesa.email);
      setEsito({tono: 'ok', testo: m});
    } catch (err) {
      setEsito({tono: 'errore', testo: `Errore ${err.codice || ''} - ${err.messaggio}`});
    }
    setInvio(false);
  };

  const bot = (regole.canali && regole.canali.telegram) || '';

  /* SENZA CONFERMA (Skin › Registrazione): «subito» = il conto e' gia' aperto,
     «operatore» = e' registrato e lo apre un operatore dal backoffice. */
  if (attesa.attivazione === 'subito') {
    return (
      <section className={'reg-pagina'} aria-label={i18next.t('Conto aperto')}>
        <h1>{i18next.t('Ciao')}{' '}{attesa.username}{i18next.t(', il tuo conto e\' aperto')}</h1>
        <p className={'reg-sotto'}>{i18next.t('Nessuna conferma da fare: puoi entrare subito con il nome utente e la password che hai scelto.')}</p>
        <button type={'button'} className={'reg-apri'} onClick={() => { try { window.sessionStorage.removeItem('lvc.contoInAttesa'); } catch (e) { /* niente */ } navigate('/login'); }}>{i18next.t('ACCEDI')}</button>
      </section>
    );
  }
  if (attesa.attivazione === 'operatore') {
    return (
      <section className={'reg-pagina'} aria-label={i18next.t('Conto in attesa')}>
        <h1>{i18next.t('Ciao')}{' '}{attesa.username}{i18next.t(', il conto e\' registrato')}</h1>
        <p className={'reg-sotto'}>{i18next.t('Resta in attesa finche\' un operatore non lo attiva: niente da confermare da parte tua. Quando e\' attivo potrai entrare con il nome utente e la password che hai scelto; se provi prima, il sito te lo dice.')}</p>
        <button type={'button'} className={'reg-apri secondario'} onClick={() => navigate('/login')}>{i18next.t('Vai all\'accesso')}</button>
      </section>
    );
  }

  return (
    <section className={'reg-pagina'} aria-label={i18next.t('Conto in attesa')}>
      <h1>{i18next.t('Ciao')}{' '}{attesa.username}{i18next.t(', manca solo la conferma')}</h1>

      {attesa.canale === 'email' && (
        <>
          <p className={'reg-sotto'}>{i18next.t('Ti abbiamo mandato una email a')}{' '}<b>{attesa.email}</b>{' '}{i18next.t('con il link di conferma: vale')}{' '}<b>{attesa.ore}{' '}{i18next.t('ore')}</b>{i18next.t('. Controlla anche la posta indesiderata.')}</p>
          <button type={'button'} className={'reg-apri secondario'} disabled={invio} onClick={rimandaOra}>{i18next.t('Rimanda la email')}</button>
        </>
      )}

      {attesa.canale === 'sms' && (
        <form onSubmit={conferma}>
          <p className={'reg-sotto'}>{i18next.t('Ti abbiamo mandato un SMS al')}{' '}<b>{attesa.telefono}</b>{' '}{i18next.t('con un codice di 8 caratteri: vale')}{' '}<b>{attesa.ore}{' '}{i18next.t('ore')}</b>.</p>
          <div className={'reg-campo'}>
            <label htmlFor={'reg-codice'}>{i18next.t('Codice ricevuto')}</label>
            <input id={'reg-codice'} type={'text'} value={codice} onChange={(e) => setCodice(e.target.value)} autoComplete={'one-time-code'} maxLength={8} style={{letterSpacing: '0.2em', textTransform: 'uppercase'}}/>
          </div>
          <button type={'submit'} className={'reg-apri'} disabled={invio || codice.trim().length < 8}>{i18next.t('CONFERMA')}</button>
          <button type={'button'} className={'reg-apri secondario'} disabled={invio} onClick={rimandaOra}>{i18next.t('Rimanda il codice')}</button>
        </form>
      )}

      {attesa.canale === 'telegram' && (
        <>
          <p className={'reg-sotto'}>{i18next.t('Apri il bot')}{' '}<b>{bot}</b>{' '}{i18next.t('su Telegram e premi «Avvia»: ti conferma il conto. Il codice vale')}{' '}<b>{attesa.ore}{' '}{i18next.t('ore')}</b>.</p>
          <a className={'reg-apri'} href={`https://t.me/${bot.replace('@', '')}`} target={'_blank'} rel={'noreferrer'}>{i18next.t('APRI IL BOT TELEGRAM')}</a>
          {/* Da collegare: il link col codice gia' dentro (t.me/<bot>?start=CODICE); oggi user-management
              manda il codice al postino ma non al sito, quindi si spiega come mandarlo a mano. */}
          <Nota>{i18next.t('Se il bot non ti risponde, scrivigli')}{' '}<b>/start</b>{' '}{i18next.t('seguito dal codice che ti arriva.')}</Nota>
        </>
      )}

      {esito.testo && <Nota tono={esito.tono === 'errore' ? 'errore' : undefined}>{esito.testo}</Nota>}
      {esito.tono === 'ok' && attesa.canale === 'sms' && (
        <button type={'button'} className={'reg-apri'} onClick={() => navigate('/login')}>{i18next.t('ACCEDI')}</button>
      )}
    </section>
  );
}
